(() => {
  const __shopifySectionId = document.currentScript?.dataset.sectionId || '';

    const sectionId = ("YurchakSignatureFit-" + __shopifySectionId + "");

    const initializeSignatureFit = () => {
      const section = document.getElementById(sectionId);

      if (
        !section ||
        section.dataset.ysfInitialized === 'true'
      ) {
        return;
      }

      section.dataset.ysfInitialized = 'true';

      const track = section.querySelector('[data-ysf-track]');

      const cards = Array.from(
        section.querySelectorAll('[data-ysf-card]')
      );

      const indicators = Array.from(
        section.querySelectorAll('[data-ysf-indicator]')
      );

      if (!track || !cards.length || !indicators.length) {
        return;
      }

      const setActiveIndicator = (activeIndex) => {
        indicators.forEach((indicator, index) => {
          const active = index === activeIndex;

          indicator.classList.toggle('is-active', active);

          indicator.setAttribute(
            'aria-current',
            active ? 'true' : 'false'
          );
        });
      };

      const getClosestCardIndex = () => {
        const trackRect = track.getBoundingClientRect();
        const trackStart = trackRect.left;

        let nearestIndex = 0;
        let nearestDistance = Infinity;

        cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();

          const distance = Math.abs(
            cardRect.left - trackStart
          );

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      };

      const scrollToCard = (index) => {
        const card = cards[index];

        if (!card) {
          return;
        }

        track.scrollTo({
          left: card.offsetLeft - track.offsetLeft,
          behavior: 'auto'
        });

        setActiveIndicator(index);
      };

      let scrollFrame = null;

      track.addEventListener(
        'scroll',
        () => {
          if (scrollFrame) {
            cancelAnimationFrame(scrollFrame);
          }

          scrollFrame = requestAnimationFrame(() => {
            setActiveIndicator(getClosestCardIndex());
          });
        },
        {
          passive: true
        }
      );

      indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => {
          scrollToCard(index);
        });
      });

      setActiveIndicator(0);
    };

    initializeSignatureFit();

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        const loadedSection =
          event.target.querySelector?.(`#${sectionId}`);

        if (!loadedSection) {
          return;
        }

        loadedSection.dataset.ysfInitialized = 'false';

        initializeSignatureFit();
      }
    );
  })();
